import useQuery from 'commons/useQuery';
import { GET_CURRENT_USER_CLIENT } from 'mocks/queries';

const useUserData = () => {
  const { data, error, loading } = useQuery(GET_CURRENT_USER_CLIENT);
  const user = data?.user;

  return {
    email: user?.email,
    error,
    firstName: user?.first_name,
    lastName: user?.last_name,
    isImpersonatingUser: !!user?.is_impersonate,
    isLoggedIn: !!user,
    isTradeUser: !!user?.is_designer,
    loading,
    userDiscount: user?.user_discount,
    user,
    userGroupId: user?.group_id,
    userId: user?.id,
  };
};

export default useUserData;
